import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { CreateLeadRequestDTO, UpdateLeadRequestDTO, LeadResponse } from "@/types";

async function createLead(
  request: CreateLeadRequestDTO
): Promise<LeadResponse> {
  const response = await httpRequest.post<LeadResponse>(
    "/clinic/crm/leads",
    request
  );
  return response.data;
}

export function useCreateLeadMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createLead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      queryClient.invalidateQueries({ queryKey: ["leads", "list"] });
    },
  });
}

async function updateLead(
  id: string,
  request: UpdateLeadRequestDTO
): Promise<LeadResponse> {
  const response = await httpRequest.put<LeadResponse>(
    `/clinic/crm/leads/${id}`,
    request
  );
  return response.data;
}

export function useUpdateLeadMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateLeadRequestDTO }) =>
      updateLead(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      queryClient.invalidateQueries({ queryKey: ["leads", "list"] });
      queryClient.invalidateQueries({ queryKey: ["leads", id] });
    },
  });
}

async function deleteLead(id: string): Promise<void> {
  await httpRequest.delete(`/clinic/crm/leads/${id}`);
}

export function useDeleteLeadMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteLead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      queryClient.invalidateQueries({ queryKey: ["leads", "list"] });
    },
  });
}